module.exports = __webpack_public_path__ + "img/aliPayCode.7ab9c5ab.png";